// extracted by mini-css-extract-plugin
module.exports = {"tableCustom":"ServiceRequestSummaryTable_AX_tableCustom__u0fFw","rowCustom":"ServiceRequestSummaryTable_AX_rowCustom__cIY5B"};